import React, {useState, useEffect, Fragment} from 'react'
import {Button, Icon} from 'semantic-ui-react'
import {SortableHandle} from 'react-sortable-hoc';

export const DragHandle = SortableHandle(({isFirst, isLast}) => <Button compact basic icon style={{
          	margin: '-19px 2px -19px -10px',
          	backgroundColor: 'transparent',
          	boxShadow: 'none',
            display: 'none'
        }}><Icon name={isFirst?"caret down":isLast?"caret up":"sort"} /></Button>);